import { Globe2, Users2 } from 'lucide-react';
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next";

const Reasons = () => {

  const { t } = useTranslation();

  const data = [
    { title: "reach_a_welth_of_travelers", image: "https://images.pexels.com/photos/34328172/pexels-photo-34328172.jpeg" },
    { title: "leverage_tech_built_for_your_business", image: "https://images.pexels.com/photos/3182829/pexels-photo-3182829.jpeg" },
    { title: "stand_out_with_powerful_advertising", image: "https://images.pexels.com/photos/244133/pexels-photo-244133.jpeg" },
   { title: "unlock_sustainable_growth",image: "https://images.pexels.com/photos/7971194/pexels-photo-7971194.jpeg?_gl=1*1777iid*_ga*ODcwMjA3Mzc5LjE3NzE5MjA5NDk.*_ga_8JE65Q40S6*czE3Nzc1NTgxMTYkbzkkZzEkdDE3Nzc1NTg0NzIkajQyJGwwJGgw"}
  ]

  return (
    <section className='py-5'>
      
      <div className='mt-5'>
        <div className='fs-1 text-center' dangerouslySetInnerHTML={{ __html: t('success_title') }}></div>
        <p className='text-center'>{t('success_caption')}</p>
        <div className='mt-5'>
          <Row className='justify-content-center row-gap-3'>
            {data.map((item,index) => (
              <Col sm="6" md="4" xl="3" key={index}>
                <div className='position-relative'>
                  <img className='rounded-4' src={item.image} width="100%" height="100%" alt={item.title} style={{ filter: "brightness(0.8)"}}/>
                  <div className='rounded-4 position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end'>
                    <div className='p-4 fs-5 text-white'>{t(item.title)}</div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </section>
  )
}

export default Reasons
